import styled from 'styled-components';
import { rem } from 'polished';
import Modal from '../../core/Modal';
import { Checkbox } from '../../core/Checkbox';
import Buttons from '../../core/Buttons';
import Icon from '../../core/Icon';
import Title from '../../core/Title';
import Text from '../../core/Text';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const COLORS = {
  orange: 'rgba(247, 155, 30, 1)',
  red: 'rgba(234, 89, 84, 1)',
  blue: 'rgba(101, 197, 219, 1)'
};

const StyledIcon = styled(Icon)`
  float: left;
  margin-right: ${props =>
    props.marginRight ? rem(props.marginRight) : 'auto'};
  margin-top: ${props => (props.marginTop ? rem(props.marginTop) : 'auto')};
  fill: ${props => (props.stroke ? props.stroke : 'black')};
`;

const StyledUl = styled.ul`
  padding-left: ${rem('70px')};
`;

const StyledText = styled(Text)`
  margin-top: ${props => (props.marginTop ? props.marginTop : 'auto')};
  text-align: justify;
  text-justify: inter-word;
`;
const StyledSpan = styled.span`
  color: ${props => COLORS[props.color]};
  font-weight: ${props => (props.bold ? 'bold' : 'normal')};
`;

const StyledCenterButton = styled(Buttons)`
  margin: ${rem('70px')} auto ${rem('30px')};
  display: flex;
  background-color: black;
  a {
    color: white;
    margin-top: ${rem('2px')};
  }
`;

const StyledImageSmall = styled.img`
  width: ${props => (props.newWidth ? rem(props.newWidth) : rem('81px'))};
  height: ${props => (props.newHeight ? rem(props.newHeight) : rem('69px'))};
  float: ${props => (props.float ? props.float : 'none')};
  margin: ${rem('10px')} ${rem('10px')} ${rem('10px')} 0;
`;

const StyledImageBig = styled.img`
  width: ${props => (props.newWidth ? rem(props.newWidth) : rem('122px'))};
  height: ${props => (props.newHeight ? rem(props.newHeight) : rem('122px'))};
  float: ${props => (props.float ? props.float : 'none')};
  margin: ${rem('10px')} ${rem('10px')} ${rem('10px')} 0;
`;

const StyledImageVideo = styled.img`
  width: ${props => (props.newWidth ? rem(props.newWidth) : rem('122px'))};
  height: ${props => (props.newHeight ? rem(props.newHeight) : rem('122px'))};
  margin-left: 8%;
  display: inline-block;
`;

const StyledHeaderIcon = styled(Icon)`
  display: flex;
  max-width: ${rem('200px')};
  margin: 0 auto ${rem('20px')};
  width: ${rem('400px')};
`;

const StyledTitle = styled(Title)`
  color: ${props => COLORS[props.color]};
  font-size: ${rem('28px')};
  margin-top: ${rem('50px')};
`;

const StyledCheckbox = styled(Checkbox)`
  margin-right: ${rem('20px')};
  label {
    font-size: ${rem('13px')};
    margin-left: ${rem('10px')};
    line-height: ${rem('19px')};
  }
  :checked ~ {
    background-color: #ffffff;
  }
`;

const StyledLinksIndexUser = styled.div`
  margin: 0 ${rem('150px')} ${rem('50px')} ${rem('150px')};
  padding-left: ${rem('2px')};
  padding-right: ${rem('2px')};
  padding-top: ${rem('3px')};
  ${mediaqueries.lessThan('mobile')`
    padding-left: ${rem('15px')};
    padding-right: ${rem('15px')};
    padding-top: ${rem('25px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    padding-left:0;
    padding-right:0;
  `};
  .form-footer {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
  }
`;

const StyledFormModal = styled(Modal)`
  .wrapper-modal {
    max-width: ${rem('400px')};
    padding-top: ${rem('40px')};
  }
  .modal-buttons {
    padding-top: ${rem('40px')};
    display: flex;
    margin: 0 auto;
    width: ${rem('253px')};
    button:first-of-type {
      margin-right: ${rem('10px')};
    }
  }
  .form-dropdown,
  .form-otros {
    margin-bottom: ${rem('20px')};
  }
  .form-label {
    margin-bottom: ${rem('10px')};
  }
  .form-radio {
    margin-right: ${rem('15px')};
  }
  .wrapper-flex {
    display: flex;
  }
`;

export {
  StyledLinksIndexUser,
  StyledFormModal,
  StyledCheckbox,
  StyledHeaderIcon,
  StyledTitle,
  StyledText,
  StyledSpan,
  StyledImageSmall,
  StyledImageBig,
  StyledCenterButton,
  StyledIcon,
  StyledUl,
  StyledImageVideo
};
